import { theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Highlight = styled.span `
  pointer-events: none;
  background-color: color-mix(in srgb, ${theme.swatches.magenta[500]}, transparent 75%);
  position: absolute;
`;
export const Text = styled.span `
  display: inline-block;
  position: absolute;
  height: 1em;
  line-height: 1;
  transform-origin: left bottom;
  white-space: pre;
  pointer-events: all;
  font-family: ${(props) => props.$fontFamily};
`;
